import { isConstructorDeclaration } from 'typescript'
import ApiService from './api.service.js'

const ChangeLogService = {
  getById: async function (id, callback) {
    try {
      let logsParams = {
        params: {
          action: 'change-log',
          Record_Id: id
        }
      }
      let logsResponse = await ApiService.get(process.env.VUE_APP_CHANGE_LOG_API, logsParams)
      callback(logsResponse.data)
    } catch (error) {
      console.log(error)
    }
  },
  getAll: async function (callback) {
    try {
      let logsParams = {
        params: {
          action: 'change-log'
        }
      }
      let logsResponse = await ApiService.get(process.env.VUE_APP_CHANGE_LOG_API, logsParams)
      console.log('------- Change Log:Get All ------')
      console.table(logsResponse)
      console.log('---------------------------------')
      callback(logsResponse.data)
    } catch (error) {
      console.log(error)
    }
  },
  create: async function (data, cb) {
    try {
      let fields = {
        changeFrom: {},
        changeTo: {}
      }
      if (data.changeFrom === null) {
        fields.changeTo = data.changeTo
      } else {
        // get only the fields that have change
        for (const key in data.changeFrom) {
          if (data.changeTo.hasOwnProperty(key)) {
            if (data.changeFrom[key] !== data.changeTo[key]) {
              fields.changeFrom[key] = data.changeFrom[key]
              fields.changeTo[key] = data.changeTo[key]
            }
          }
        }
      }
      // init request
      if (fields.changeFrom !== null && fields.changeTo !== null) {

        let logAction

        if (data.action) {
          logAction = data.action
        } else if (data.changeFrom === null) {
          logAction = 'Add'
        } else {
          logAction = 'Update'
        }

        let logReqBody = {
          action: 'change-log',
          Action: logAction,
          Change_From: JSON.stringify(fields.changeFrom, undefined, 2),
          Change_To: JSON.stringify(fields.changeTo, undefined, 2),
          Record_Id: data.id,
          Record_Module: data.module,
          User: vm.$store.state.currentUser.name
        }
        let logPostRes = await ApiService.post(process.env.VUE_APP_CHANGE_LOG_API, logReqBody)
        if (cb) {
          cb() 
        }
        console.log('new log added')
      }
    } catch (error) {
      console.log(error)
      throw new Error()
    }
  },
  createMultiple: async function (logs) {
    try {
      logs.id.forEach((id, index) => {
        let logReqBody = {
          action: 'change-log',
          Action: 'MassUpdate',
          Change_From: JSON.stringify(logs.changeFrom[index], undefined, 2),
          Change_To: JSON.stringify(logs.changeTo, undefined, 2),
          Record_Id: id,
          User: vm.$store.state.currentUser.name
        }
        ApiService.post(process.env.VUE_APP_CHANGE_LOG_API, logReqBody)
        console.log('new log added')
      })
    } catch (error) {

    }
  }
}

export default ChangeLogService
